import React, { Component, ReactNode } from 'react';
import './SelectFile.scss';
import { AuthLayout } from '../layouts/auth-layout/AuthLayout';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import RoleDisplay from '../features/role-display/RoleDisplay';
import { Api } from '../api';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { ERouterPath } from '../features/router/ERouterPath';
import { sessionActions } from '../app/session/actions';
import { DossierV2 } from '../models/DossierV2';
import { DossierMember } from '../models/DossierMember';
import { MultiDossierUnreadStatus } from '../models/UnreadStatus';
import { Badge } from '../features/badge/Badge';
import { Alert } from 'react-bootstrap';

interface ISelectableDossier {
  dossier: DossierV2;
  dossierRelations: DossierMember[];
  relation: DossierMember;
}

interface SelectFileProps extends RouteComponentProps {
  setActiveDossier: (dossier: DossierV2, dossierRelations: DossierMember[], relation: DossierMember) => void;
  clearActiveDossier: () => void;
}

interface SelectFileState {
  selectableDossiers?: ISelectableDossier[];
  selected?: ISelectableDossier;
  unreadState: MultiDossierUnreadStatus;
  firstTimeLogin?: boolean;
}

class SelectFilePage extends Component<SelectFileProps, SelectFileState> {
  constructor(props: SelectFileProps) {
    super(props);
    this.state = {
      firstTimeLogin: this.getIfFirstLogin(this.props.location.search),
      unreadState: new MultiDossierUnreadStatus({}),
    };
  }

  componentDidMount(): void {
    this.loadDossiers();
  }

  loadDossiers(): void {
    Api.listUserDossiersWithUserRelation()
      .then(list => {
        this.setState({ selectableDossiers: list });
      })
      .catch((error) => console.error('Loading dossiers failed:', error));

    Api.getUnreadStatusAllDossiers()
      .then(response => this.setState({ unreadState: response }))
      .catch(err => console.error('Failed to get all dossier status', err));
  }

  getIfFirstLogin(query: string): boolean {
    return query.includes('firstTimeLogin');
  }

  handleClick = (dossier?: ISelectableDossier): void => {
    this.setState({ selected: dossier });
  };

  handleContinue = (): void => {
    const { firstTimeLogin, selected } = this.state;
    if (selected) {
      this.props.setActiveDossier(selected.dossier, selected.dossierRelations, selected.relation);
    } else {
      this.props.clearActiveDossier();
    }

    if (firstTimeLogin) {
      this.props.history.push(ERouterPath.accountSettings);
    } else {
      this.props.history.push(ERouterPath.dossier);
    }
  };

  renderDossiers(): ReactNode[]|ReactNode {
    const { selectableDossiers, selected, unreadState } = this.state;
    const selectedClass = 'file-button--selected';
    if (selectableDossiers) {
      return selectableDossiers.map((selectable: ISelectableDossier, i: number) => (
        <button
          key={i}
          className={`select-file__file-button file-button ${selected?.dossier?.match(selectable.dossier) ? selectedClass : ''}`}
          onClick={() => this.handleClick(selectable)}
        >
          <RoleDisplay className="file-button__display" dossier={selectable.dossier} dossierRelation={selectable.relation} />
          <Badge count={unreadState[selectable.dossier.id]?.total} />
        </button>
      ));
    } else {
      return <Spinner animation="border" variant="primary" />;
    }
  }

  handleLogout = (): void => {
    this.props.history.push(ERouterPath.logout);
  };

  render(): ReactNode {
    const { selected, selectableDossiers } = this.state;
    const tip = 'Jouw account bevat meerdere dossiers. Selecteer het dossier die je wilt inzien.';
    return (
      <AuthLayout tip={ selectableDossiers && selectableDossiers.length > 1 ? tip : ''}>
        { (selectableDossiers && selectableDossiers.length === 0) && <Alert variant="info">Het lijkt er op dat er geen dossiers zijn waar je toegang to hebt.</Alert>}
        <div className="select-file">
          <div className="select-file__separator"> { selectableDossiers && selectableDossiers.length > 1 ? tip : ''} </div>
          { this.renderDossiers() }
        </div>
        <Button
          className="select-file__submit"
          disabled={!selected}
          onClick={this.handleContinue}
        >
          Doorgaan
        </Button>
        <Button variant="link" onClick={this.handleLogout}>
          Uitloggen
        </Button>
      </AuthLayout>
    );
  }
}

export const SelectFile = connect(
  null,
  dispatch => ({
    setActiveDossier: (dossier: DossierV2, dossierRelations: DossierMember[], relation: DossierMember) => dispatch(sessionActions.setDossier({ dossier, dossierRelations, relation })),
    clearActiveDossier: () => dispatch(sessionActions.clearDossier())
  })
)(withRouter(SelectFilePage));
